import React from 'react';
import './loading-style.css';

const Loading = ({ color }) => {
    const backgroundColor = color || '#000';
    return (
        <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube2" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube3" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube4" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube5" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube6" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube7" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube8" style={{ backgroundColor }} />
            <div className="sk-cube sk-cube9" style={{ backgroundColor }} />
        </div>

    )
};

export default Loading;


// WEBPACK FOOTER //
// ./src/components/loading/presentational/Loading.js